<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Customer Complaint - Choose Owner</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Complaint Number</label>
                <input type="text" class="form-control" id="complaint-no" v-model="cci.complaintNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">CCF Log Date</label>
                <!-- <input type="text" class="form-control" id="reported-date" v-model="cci.reportedDate" disabled> -->
                <flat-pickr class="form-control" id="reported-date" v-model="cci.reportedDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Distributed to Internal</label>
                <input type="text" class="form-control" id="distributed-internal" v-model="cci.distributedToInternal" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Complaint Received Date</label>
                <flat-pickr class="form-control" id="reported-date" v-model="cci.receivedDate" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Customer</label>
                <input type="text" class="form-control" id="customer" v-model="cci.customerName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Brand</label>
                <input type="text" class="form-control" id="brand" v-model="cci.productName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Product</label>
                <input type="text" class="form-control" id="product" v-model="cci.productName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Plant</label>
                <input type="text" class="form-control" id="plant" v-model="cci.plantName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Address</label>
                <textarea class="form-control" id="address" v-model="cci.address" rows="2" disabled></textarea>
            </div>
            <div class="form-group col-3">
                <label for="module">PIC</label>
                <input type="text" class="form-control" id="pic" v-model="cci.pic" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Email</label>
                <input type="text" class="form-control" id="email" v-model="cci.email" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Phone</label>
                <input type="text" class="form-control" id="phone" v-model="cci.phone" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">BL Date</label>
                <!-- <input type="text" class="form-control" id="bl-date" v-model="cci.blDate" disabled> -->
                <flat-pickr class="form-control" id="bl-date" v-model="cci.blDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Dispatch Date</label>
                <!-- <input type="text" class="form-control" id="dispatch-date" v-model="cci.dispatchDate" disabled> -->
                <flat-pickr class="form-control" id="dispatch-date" v-model="cci.dispatchDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Container No.</label>
                <input type="text" class="form-control" id="container-no" v-model="cci.containerNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Packaging</label>
                <input type="text" class="form-control" id="packaging" v-model="cci.packagingName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Discharge Port</label>
                <input type="text" class="form-control" id="discharge-port" v-model="cci.dischargePortName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Country Name</label>
                <input type="text" class="form-control" id="country" v-model="cci.countryName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Incoterms</label>
                <input type="text" class="form-control" id="model-of-delivery" v-model="cci.modelOfDeliveryName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Conformance Type</label>
                <input type="text" class="form-control" id="conformance-type" v-model="cci.conformanceTypeName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Complaint Media</label>
                <input type="text" class="form-control" id="complaint-media" v-model="cci.complaintMediaName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Enclosed</label>
                <input type="text" class="form-control" id="enclosed" v-model="cci.enclosedName" disabled>
            </div>
        </div>
         <div class="row">
            <div class="form-group col-12">
                <label for="module">Description</label>
                <textarea class="form-control" id="description" v-model="cci.description" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div v-if="this.cci.ccSalesAttachment !== ''" class="form-group col-12">
               <a :href="this.cci.ccSalesAttachment" class="badge badge-primary">Download Attachment from Sales</a>
            </div>
            <div v-if="this.cci.ccSalesAttachment === ''" class="form-group col-12">
               <a style="color: white;" class="badge badge-secondary">No Attachment from Sales</a>
            </div>
        </div>
        <br/>
        <app-datatable :type="'view'" :elements="dtElementsDetail" :collections="cci.customerComplaintDetail"></app-datatable>
        <br /><br />
        <app-datatable :type="'view'" :elements="dtElements" :collections="cci.detail" v-on:selectedRow="selectRow"></app-datatable>
        <div class="row">
            <div class="form-group col-6">
              <label for="owner-member">Owner Area</label>
              <app-lookup-field :model="cci" :element="ownerLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div class="form-group col-3">
              <label for="happened-before">Happened Before</label>
              <input type="checkbox" class="form-control" v-model="cci.happenedBefore" id="happened-before">
            </div>
            <!-- client ask to hide this (Harris) - 2Nov2020 -->
            <!-- <div v-if="this.cci.ccAreaOwnerAttachment !== ''" class="form-group col-3">
               <a :href="this.cci.ccAreaOwnerAttachment" class="badge badge-primary">Download Attachment from Area Owner</a>
            </div>
            <div v-if="this.cci.ccAreaOwnerAttachment === ''" class="form-group col-3">
               <label for="module">Please Submit your Investigation</label>
                <app-uploader :fileUrl="cci.ccAreaOwnerAttachment" :fieldName="'ccAreaOwnerAttachment'" v-on:finishUpload="finishUpload(...arguments)"></app-uploader>
            </div> -->
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { customerComplaintChooseOwner, customerComplaintChooseOwnerDetail } from '../../models/customerComplaintInvestigation'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppUploader from '../../components/AppUploader.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable, AppUploader
    },
    data() {
        return {
          cci: {...customerComplaintChooseOwner, customerComplaintDetail: [], detail: []},
          newDetail: customerComplaintChooseOwnerDetail,
          selectedId: '',
          dtElementsDetail: [
                {
                    title: 'PO',
                    column: 'po',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'SO',
                    column: 'so',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Batch',
                    column: 'batch',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Qty',
                    column: 'qty',
                    type: 'text',
                    width: 6,
                },
          ],
          dtElements: [
            {
              title: 'Question',
              column: 'question',
              type: 'text'
            },
            {
              title: 'Responder',
              column: 'responder',
              type: 'text'
            },
            {
              title: 'Email',
              column: 'email',
              type: 'text'
            },
            {
              title: 'Answer',
              column: 'answer',
              type: 'text'
            },
            {
              title: 'Attachment',
              column: 'attachment',
              type: 'link'
            },
            {
              title: 'Answered At',
              column: 'answeredAt',
              type: 'date'
            },
          ],
          ownerLookup: {
              id: 'owner-area',
              title: 'Owner Area',
              type: 'form',
              apiUrl: 'member-management/lookup',
              filter: ['firstName', 'lastName', 'email'],
              fields: [
                  {
                      placeholder: 'Name',
                      width: 6,
                      column: 'ownerMemberName'
                  },
                  {
                      placeholder: 'Email',
                      width: 6,
                      column: 'ownerMemberEmail'
                  },
              ],
              dtElements: [
                  {
                      title: 'Name',
                      column: 'firstName'
                  },
                  {
                      title: 'Email',
                      column: 'email'
                  },
              ],
              affectedField: [
                  {
                      from: 'id',
                      to: 'ownerMemberId'
                  },
                  {
                      from: 'firstName',
                      to: 'ownerMemberName'
                  },
                  {
                      from: 'email',
                      to: 'ownerMemberEmail'
                  },
              ]
          },
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const cciApi = api('customer-complaint-investigation')
            this.cci = await cciApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const cciApi = api('customer-complaint-choose-owner')
            if(this.$route.query.id !== undefined) {
                await cciApi.update(this.cci, this.$route.query.id)
            }
            console.log(this.cci)
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        cancel() {
            this.$router.go(-1)
        },
        selectRow(id) {
          this.selectedId = id
        },
        finishLookup(data) {
            const currentCcs = this.cci
            this.cci = {
                ...currentCcs,
                ...data
            }
        },
        finishUpload(data) {
            const currentCcs = this.cci
            this.cci = {
                ...currentCcs,
                ...data
            }
        },
    }
}
</script>